import { useParams } from "react-router-dom";
import { getDatabase, ref, onValue } from "firebase/database";
import { useState, useEffect } from "react";

import app from "../utils/firebase";

function Note() {
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState(undefined);
  const [to, setTo] = useState(undefined);
  const [content, setContent] = useState(undefined);

  const { at } = useParams();

  useEffect(() => {
    const db = getDatabase(app);
    const noteRef = ref(db, 'notes/' + at);

    const unsubscribe = onValue(noteRef, (snapshot) => {
      const data = snapshot.val();
      if (data?.content) {
        setContent(data.content);
        setFrom(data.from);
        setTo(data.to);
      } else {
        setContent(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, [at]);

  const renderContent = () => (
    <div className="note-quote-block">
      {content !== null && <h1 className="aspas">"</h1>}
      <h4 className="text-center note-text">
        {content || "Ops, ainda não preparei nada 😳"}
      </h4>
      {content !== null && <h1 className="aspas text-end">"</h1>}
    </div>
  );

  return (
    <div id="notes" className="note note-page">
      <div className="note-page-spacer" aria-hidden="true" />
      <div className="note-page-center">
        <div className="container note-body">
          {loading
            ? <h4 className="text-center note-text">...</h4>
            : renderContent()
          }
        </div>
      </div>
      {!loading && (
        <h3 className="note-from">
          {!!from && `De: ${from}`}
          {(!!from && !!to) && <br />}
          {!!to && `Para: ${to}`}
        </h3>
      )}
    </div>
  );
}

export default Note;
